module.exports = __webpack_public_path__ + "static/media/astro_financial.737fbfe3.png";